<template>
    <div>
        <div v-if="!apiKey">No API key available.</div>
        <div v-if="apiKey">
            <syntaxer lang="html" :text="code" />
        </div>
    </div>
</template>

<script>
import store from "@/services/store";
import { embed } from "@/services/widgets";
import Syntaxer from "@/components/common/Syntaxer";

export default {
    props: ["id"],
    data: () => ({
        code: "",
        apiKey: null
    }),
    components: { Syntaxer },
    mounted() {
        this.updateCode();
    },
    methods: {
        updateCode() {
            this.apiKey = store.state.id.apiKey;
            const props = {
                "api-key": this.apiKey,
                "product-id": this.id
            };
            this.code = embed("primalgo", props);
        }
    }
}
</script>